module.exports = __webpack_public_path__ + "static/mreavesxlsannarri-020415006EmigreWebOnly-31dcb402a050ead5f4367e5fdd1c45a4.ttf";